import { db } from './firebaseConfig';
import { collection, query, where, getDocs, getDoc, doc } from 'firebase/firestore';

export const obtenerMembresiaActiva = async (userId) => {
  const q = query(
    collection(db, "membresias"),
    where("estudianteId", "==", userId)
  );

  const snap = await getDocs(q);

  console.log(
    "USER ID:",
    userId
  );
  
  console.log(
    "MEMBRESIAS ENCONTRADAS:",
    snap.size
  );

  const hoy = new Date();

  let activa = null;

  snap.forEach((docu) => {
    const data = docu.data();

    if (
      data.estadoPago !== "cancelado" &&
      data.fechaInicio?.toDate() <= hoy &&
      data.fechaFin?.toDate() >= hoy
    ) {
      activa = data;
    }

    console.log(
      "MEMBRESIA:",
      docu.id,
      docu.data()
    );

  });

  // 🔥 NUEVO: traer plan
  if (activa?.planId) {
    console.log("PLAN ID:", activa.planId);
    const planRef = doc(db, "planes", activa.planId);
    const planSnap = await getDoc(planRef);

    if (planSnap.exists()) {
      activa.plan = planSnap.data();
    }
  }

  console.log(
    "MEMBRESIA ACTIVA FINAL:",
    activa
  );

  return activa;
};